import $ from 'jquery';
import 'slick-carousel';

function homeHero() {
	var $slider = $('.c-home-hero_slider'),
			$title 	= $('.c-home-hero_industry-title');

	$slider.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 8000,
		fade: true,
		rows: 0,
	});

	$slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
		$title.each(function() {
			if ( $(this).data('hero-select') == currentSlide ) {
				$title.removeClass('is-active');
				$(this).addClass('is-active');
			}
		});
	});

	$title.click(function() {
		var $slide = $(this).data('hero-select');
		$slider.slick('slickGoTo', $slide);
		$title.removeClass('is-active');
		$(this).addClass('is-active');
	});	
}

export { homeHero };